import { createFileRoute, redirect } from '@tanstack/react-router';
import { toast } from 'sonner';
import { UsersPage } from '@/features/settings/users/UsersPage';
import { t } from '@/i18n/useT';

/** Réservée aux admins : un membre est renvoyé vers `/settings/scoring` avec un toast. */
export const Route = createFileRoute('/_auth/settings/users')({
  beforeLoad: ({ context }) => {
    if (context.me.user.role !== 'admin') {
      toast.error(t('errors.forbidden'));
      throw redirect({ to: '/settings/scoring', replace: true });
    }
  },
  component: UsersPage,
});
